import createImageIcon from './createImageIcon';
import path from './B-thin.svg';

export default createImageIcon({displayName: 'MarkerBIcon', path});



// WEBPACK FOOTER //
// ./src/common/components/icons/MarkerBIcon.js